<template>
  <b-modal
    title="Transaction Details"
    id="wallet-transaction-modal"
    ref="wallet_transaction_detail"
    centered
    ok-only
  >
    <div class="modal-wrap">
      <b-row>
        <b-col cols="6">
          <small>Amount:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0">{{ formatMoney(transaction.amount) }}</h6>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6">
          <small>Balance:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0">{{ formatMoney(transaction.balance) }}</h6>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6">
          <small>Reference:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0">{{ transaction.reference }}</h6>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6">
          <small>Type:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0" :class="transaction.transactiontype">{{ transaction.transactiontype }}</h6>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6">
          <small>Kind:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0">{{ transaction.entity }}</h6>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6">
          <small>Description:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0">{{ transaction.description }}</h6>
        </b-col>
      </b-row>
      <hr />
      <b-row>
        <b-col cols="6">
          <small>Date:</small>
        </b-col>
        <b-col cols="6">
          <h6 class="mb-0">
            {{
            LuxonDateTime.fromJSDate(new Date(transaction.createdat)).toFormat(
            "LLL dd yyyy"
            )
            }}
          </h6>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { DateTime as LuxonDateTime } from "luxon";
import { formatMoney } from "@/utils/helpers";

export default {
  props: {
    transaction: null
  },
  data() {
    return {
      LuxonDateTime: LuxonDateTime
    };
  },
  methods: {
    formatMoney
  }
};
</script>

<style lang="scss" scoped>
#wallet-transaction-modal {
  .credit {
    background-color: #ceface !important;
    display: inline;
    padding: 10px;
    border-radius: 6px;
  }

  .debit {
    background-color: #ffdbd8 !important;
    display: inline;
    padding: 10px;
    border-radius: 6px;
  }
}
</style>
